<template>
<div id="chat">
  <div v-for="(item, index) in list" :key="index">
    <div class="chat_question" style="overflow: hidden;">
      <div style="float: left;">问:</div><div><el-input v-model="item.question" @input="updateData(index)" /></div>
    </div>
    <div class="chat_answer" style="overflow: hidden;">
      <div style="float: left">答: </div><div style="float: left;" v-html="item.answer"></div>
    </div>
  </div>
  <div>
    <el-button type="primary" @click="search()" :loading="loadingStatus">搜索</el-button>
  </div>
</div>
</template>

<script>
import {chat} from "../../api/chat";

export default {
  name: "chat",
  data() {
    return {
      visible: false,
      list: [
        {
          question: '',
          answer: ''
        }
      ],
      loadingStatus: false
    }
  },
  methods: {
    chat() {
      this.visible = true
    },
    updateData(index) {
      this.$forceUpdate()
    },
    search() {
      const index = this.list.length - 1
      if (this.list[index].question === '' || typeof this.list[index].question === 'undefined') {
        return false
      }
      this.requestData(this.list[index].question)
    },
    requestData(search) {
      this.loadingStatus = true
      chat({ ask: search }).then((res) => {
        console.log('res..........', res, res.data.data[0])
        if (res.data.data && res.data.data[0]) {
          const index = this.list.length - 1
          this.list[index].answer = res.data.data[0].text.replace('/\n/g', '<br />')
          this.list[index + 1] = {
            question: '',
            answer: ''
          }
          this.$forceUpdate()
          this.loadingStatus = false
        }
      })
    }
  }
}
</script>

<style scoped>
  #chat {
    width: 90%;
    margin: 5vh auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/chat.vue